module.exports = __webpack_public_path__ + "bc571e7cbc49d308d841426c2a5b7f33.mp4";